(function ($) {
	$(document).ready(function () {
		if ($('.kc-carousel-all-collab').length > 0) {
			kc_ajax_get_collab($('.kc-carousel-filter').first());

			$('.kc-carousel-filter').click(function () {
				kc_ajax_get_collab($(this));
			});
		}

		if ($('.kc-carousel-collab-device').length > 0) {
			new Splide('.kc-carousel-collab-device', {
				perPage: 3,
				rewind: true,
				breakpoints: {
					768: {
						perPage: 1
					}
				},
				gap: 'var(--space-small)'
			}).mount();
		}
	});

	function kc_ajax_get_collab(element) {
		$('.kc-carousel-all-collab').html('<div class="lds-dual-ring"></div>');
		$('.kc-carousel-filter').removeClass('active');
		element.addClass('active');

		$.ajax({
			url: KcAjax.url,
			type: 'POST',
			data: {
				action: 'kc_get_collabs',
				filters: element.data('id')
			}
		}).done(function (response) {
			response = $.parseJSON(response);

			if (response.success == true) {
				$('.kc-carousel-all-collab').html(response.template);

				new Splide('.kc-carousel-all-collab', {
					perPage: 2,
					rewind: true,
					gap: 'var(--space-small)',
					breakpoints: {
						768: {
							perPage: 1
						}
					}
				}).mount();
			}
		});
	}
})(jQuery);
